import modelMappings from 'lib/preprocessedModels';

export function fetchModelSrc(modelName: string): string {
  if (modelMappings && modelName in modelMappings) {
    return new URL(modelMappings[modelName], import.meta.env.VITE_CDN_HOST).href;
  } else {
    return (document.querySelector(`meta[name="model-src-${modelName}"]`) as HTMLMetaElement)
      ?.content;
  }
}
